import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  secondaryTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-primary-500">
        <i className="ri-search-eye-line text-2xl" />
      </span>
      <h3 className="mt-4 text-base font-semibold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {actionLabel}
          </button>
        )}
        {secondaryLabel && secondaryTo && (
          <Link
            to={secondaryTo}
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}